module.exports = __webpack_public_path__ + "static/card-img-5-12810d17369041dbd5539947503cbcc9.jpg";